import styled from '@emotion/styled';
import { colors } from 'crono-fe-common/theme';

export const StepsForRewriteOptionsWrapper = styled.div`
  width: 100%;
  padding: 8px;
  height: 100%;
  overflow: auto;

  .select-option {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 2px;
    border-radius: 8px;
    width: 100%;
    cursor: pointer;
    &:hover {
      background-color: ${colors.sequenceCardHover};
    }
  }

  .steps-for-rewrite-option-divider:last-of-type {
    display: none;
  }
`;

export const StepsForRewriteSelectWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 40px;
  border: 1px solid ${colors.grey4};
  border-radius: 8px;
  align-items: center;
  padding: 7px 7px 7px 14px;
  cursor: pointer;
`;
